import { TradedFacilityState } from './reducer'

export const getTradedFacilities = (state: {
  tradedFacilities: TradedFacilityState
}) => state.tradedFacilities.tradedFacilities.data

export const getTradedFacilitiesLoader = (state: {
  tradedFacilities: TradedFacilityState
}) => state.tradedFacilities.tradedFacilities.isLoading